export const BASE_URL = 'https://www.googleapis.com/books/v1/volumes'
export const KEY_API = 'AIzaSyBwFcuLF5gXKVlqp6RDj3xEUGW7UscSY6k'
